import { render, staticRenderFns } from "./attachFile.vue?vue&type=template&id=74b350c2&scoped=true"
import script from "./attachFile.vue?vue&type=script&lang=js"
export * from "./attachFile.vue?vue&type=script&lang=js"
import style0 from "./attachFile.vue?vue&type=style&index=0&id=74b350c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b350c2",
  null
  
)

export default component.exports